import React from 'react';
import styled from 'styled-components';
import { Link } from 'gatsby';

// @ts-ignore
import logo from '../../assets/img/svg/logo.svg';

const StyledLogo = styled.img.attrs({ src: logo })`
  width: auto;
  height: 34px;
`;

const Logo = () => {
  return (
    <Link to="/">
      <StyledLogo />
    </Link>
  );
};

export default Logo;
